import calc from 'calculatorjs'

// 当前 formulas 有 isAllIncTax 守卫，finalSr 没有；裁决前由 skipAllIncTaxGuard 显式保留差异。
function resolveBaseFormulas (ctx, { skipAllIncTaxGuard }) {
  const { sr } = ctx
  let formulas = sr.parcelsFeeFormulas
  if (ctx.isBizFee && sr.transport) {
    formulas = sr.parcelsFeeFormulasBiz
  } else if (
    sr.transport !== 'sea' &&
    ctx.jyoShpMethod === '1' &&
    (skipAllIncTaxGuard || !ctx.isAllIncTax)
  ) {
    if (ctx.useFeeType === 'frt') {
      formulas = sr.parcelsFeeFormulasFrt
    } else if (ctx.useFeeType === 'tax') {
      formulas = sr.parcelsFeeFormulasInclTax
    }
  }
  return formulas
}

function applyHctMinWeight (formulas, sr, { finalUseFirstCarrier }) {
  const minWeight = sr?.srExtras?.carriersMinWeight?.hct?.minWeight
  if (finalUseFirstCarrier === 'hct' && minWeight && formulas.srChgWeight > 0) {
    if (formulas.srChgWeight < minWeight) {
      const result = JSON.parse(JSON.stringify(formulas))
      result.srChgWeight = minWeight
      result.fwFees[0] = minWeight / 1000
      result.fwFees[4] = calc.mul(result.fwFees[0], result.fwFees[2])
      result.parcelsFee = result.fwFees[4]
      return result
    }
  }
  return formulas
}

function computeFeeFormulas (ctx, options) {
  const base = resolveBaseFormulas(ctx, options)
  // eslint-disable-next-line prefer-const -- MGB 副本在品牌围栏内重赋值。
  let formulas = base
  return applyHctMinWeight(formulas, ctx.sr, ctx)
}

export function computeParcelsFeeFormulas (ctx) {
  return computeFeeFormulas(ctx, {
    requireEconomyLabel: false,
    skipAllIncTaxGuard: false,
  })
}

export function computeFinalSrParcelsFeeFormulas (ctx) {
  return computeFeeFormulas(ctx, {
    requireEconomyLabel: true,
    skipAllIncTaxGuard: true,
  })
}
